import { render, staticRenderFns } from "./ReneweModal.vue?vue&type=template&id=45523064&"
import script from "./ReneweModal.vue?vue&type=script&lang=js&"
export * from "./ReneweModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports